import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageRootWrapper from '../../components/common/PageRoot/PageRootWrapper';
import LoginContainer from '../../components/Login/LoginContainer';

const Login = ({ location }) => (
    <PageRootWrapper location={location} withAppBar={false}>
        <LoginContainer location={location} />
    </PageRootWrapper>
);

Login.propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
};

export default Login;
